import { useLocation } from "wouter";

export function AuthFooter({
  mode,
  onModeSwitch,
}: {
  readonly mode: "login" | "register";
  readonly onModeSwitch: () => void;
}) {
  const [, navigate] = useLocation();

  return (
    <div className="flex flex-col gap-2 text-xs text-ink-muted text-center">
      <p>
        {mode === "login" ? (
          <>
            Pas encore de compte ?{" "}
            <button onClick={onModeSwitch} className="text-accent hover:underline">
              Créer un compte
            </button>
          </>
        ) : (
          <>
            Déjà un compte ?{" "}
            <button onClick={onModeSwitch} className="text-accent hover:underline">
              Se connecter
            </button>
          </>
        )}
      </p>
      <p>
        <button
          onClick={() => navigate("/")}
          className="text-ink-muted hover:text-accent hover:underline"
        >
          &larr; Retour à l'accueil
        </button>
      </p>
    </div>
  );
}
